import script from "./SelectColor.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectColor.vue?vue&type=script&setup=true&lang=js"

import "./SelectColor.vue?vue&type=style&index=0&id=f02bcb94&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\e2efreight\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f02bcb94"]])

export default __exports__